export const searchFieldKeys = {
    PHONE:"phone",
    BUSINESS_NAME:"businessName",
  }
export const FIREBASE_DB_NAME = "groups";
export const queryFieldNames = {
    BOT_NUMBER:"botNumber",
    AGENT_CHAT_STATUS:"agentChatStatus",
    AI_CHAT:"aiChat",
    AGENT_ID:"agentId",
    TICKET_STATUS:"ticketStatus",
    LAST_UPDATED_AT:"lastUpdatedAt",
  } 
  
export const inOrderTO={
    INC:"inc",
    DESC:"desc"
  }
